import * as React from 'react';

// import { Translate } from 'react-localize-redux';

import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import { Dinero } from 'dinero.js';

interface EarningsListCtrlProps {
  className?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  revenue: Dinero;
  totalWeekly?: string;
  isPro?: boolean;
}

export const EarningsListCtrl: React.FC<EarningsListCtrlProps> = (props) => {
  return (
    <ListRow className={props.className} hasOpacity={props.revenue.isZero()}>
      <ListRowWrapper justifyContent="space-between" alignItems="baseline">
        <Category>
          <Typography type="title" weight="400">
            {props.title}
          </Typography>
          {props.subtitle && (
            <Typography weight="400" opacity=".5" className="mt-5">
              {props.subtitle}
            </Typography>
          )}
        </Category>
        <Typography type="title" weight="400">
          {props.revenue.isZero() ? '-' : props.revenue.toFormat()}
        </Typography>
      </ListRowWrapper>
      {/* {props.isPro && (
        <ListRowWrapper
          className="mt-10"
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Category noDot>
            <Typography opacity=".5">
              <Translate id="USER_PROFILE.WALLET.EARNINGS.WEEK" />
            </Typography>
          </Category>
          <Typography type="title" weight="400">
            {props.totalWeekly}
          </Typography>
        </ListRowWrapper>
      )} */}
    </ListRow>
  );
};

export default EarningsListCtrl;

const ListRow = styled.div<{ hasOpacity?: boolean }>`
  padding: 15px 0;
  border-bottom: 2px dotted ${({ theme }) => theme.colors.border};

  ${({ hasOpacity }) =>
    hasOpacity &&
    css`
      & > * {
        opacity: 0.5;
      }
    `}
`;

const ListRowWrapper = styled(Flex)`
  width: 100%;
`;

const Category = styled.div<{ noDot?: boolean }>`
  padding-left: 30px;
  position: relative;

  &:after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primary};
    position: absolute;
    top: 4px;
    left: 0;
  }

  ${({ noDot }) =>
    noDot &&
    css`
      &:after {
        content: none;
      }
    `}
`;
